"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateField = exports.unsetGroupValue = exports.setValue = exports.setTouched = exports.setMetaValue = exports.setInitialValues = exports.setGroupValue = exports.setForceShowErrors = exports.setFocused = exports.setErrors = exports.setError = exports.setDefaultValue = exports.removeItemFromValueArray = exports.removeItemFromTouchedArray = exports.removeItemFromErrorsArray = exports["default"] = exports.clearForm = exports.clearForceShowErrors = exports.checkForceShowErrors = exports.addMinimumItemsToValuesArray = exports.addItemToValuesArray = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _lodash = require("lodash");
var _keepOrUnsetPathRecursively = _interopRequireDefault(require("../../../utilities/keepOrUnsetPathRecursively"));
var _unsetPathRecursively = _interopRequireDefault(require("../../../utilities/unsetPathRecursively"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var defaultInitialState = {
  errors: {},
  meta: {
    forceShowErrors: {}
  },
  touched: {},
  values: {}
};
var formSlice = (0, _toolkit.createSlice)({
  name: 'form',
  initialState: defaultInitialState,
  reducers: {
    //
    // General
    //
    clearForm: function clearForm() {
      return defaultInitialState;
    },
    //
    // errors
    //
    setError: function setError(state, action) {
      var _action$payload = action.payload,
        name = _action$payload.name,
        value = _action$payload.value;
      if (value) {
        (0, _lodash.set)(state.errors, name, value);
      } else {
        state.errors = (0, _unsetPathRecursively["default"])(state.errors, (0, _lodash.toPath)(name));
      }
      return state;
    },
    setErrors: function setErrors(state, action) {
      var errors = action.payload;
      for (var _i = 0, _Object$entries = Object.entries(errors); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          name = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        if (value) {
          (0, _lodash.set)(state.errors, name, value);
        } else {
          state.errors = (0, _unsetPathRecursively["default"])(state.errors, (0, _lodash.toPath)(name));
        }
      }
      return state;
    },
    removeItemFromErrorsArray: function removeItemFromErrorsArray(state, action) {
      var _action$payload2 = action.payload,
        index = _action$payload2.index,
        name = _action$payload2.name;
      var path = (0, _lodash.toPath)(name);
      var value = (0, _lodash.get)(state.errors, path);
      if (value) {
        value.splice(index, 1);
        (0, _lodash.set)(state.errors, path, value);
      }
      state.errors = (0, _keepOrUnsetPathRecursively["default"])(state.errors, path);
      return state;
    },
    validateField: function validateField(state, action) {
      var _action$payload3 = action.payload,
        name = _action$payload3.name,
        _action$payload3$vali = _action$payload3.validate,
        validate = _action$payload3$vali === void 0 ? function () {} : _action$payload3$vali,
        value = _action$payload3.value;
      var result = validate(value, state.values, state.meta);
      if (result) {
        (0, _lodash.set)(state.errors, name, result);
      } else {
        state.errors = (0, _unsetPathRecursively["default"])(state.errors, (0, _lodash.toPath)(name));
      }
      return state;
    },
    //
    // meta
    //
    checkForceShowErrors: function checkForceShowErrors(state, action) {
      var errors = action.payload.errors;
      var keys = Object.keys(state.meta.forceShowErrors || {}).filter(function (key) {
        return !errors[key] || Object.keys(errors[key]).length === 0;
      });
      if (keys.length > 0) {
        state.meta.forceShowErrors = (0, _lodash.omit)(state.meta.forceShowErrors, keys);
      }
      return state;
    },
    clearForceShowErrors: function clearForceShowErrors(state) {
      state.meta.forceShowErrors = {};
      return state;
    },
    setFocused: function setFocused(state, action) {
      var _action$payload4 = action.payload,
        name = _action$payload4.name,
        _action$payload4$valu = _action$payload4.value,
        value = _action$payload4$valu === void 0 ? true : _action$payload4$valu;
      if (state.meta.focusedField === name && !value) {
        state.meta.focusedField = undefined;
      } else {
        state.meta.focusedField = name;
      }
      return state;
    },
    setForceShowErrors: function setForceShowErrors(state, action) {
      var _action$payload5 = action.payload,
        name = _action$payload5.name,
        value = _action$payload5.value;
      if (state.meta.forceShowErrors === undefined) {
        state.meta.forceShowErrors = {};
      }
      (0, _lodash.set)(state.meta.forceShowErrors || {}, name, value);
      return state;
    },
    setMetaValue: function setMetaValue(state, action) {
      (0, _lodash.set)(state.meta, (0, _lodash.toPath)(action.payload.name), action.payload.value);
      return state;
    },
    //
    // touched
    //
    removeItemFromTouchedArray: function removeItemFromTouchedArray(state, action) {
      var _action$payload6 = action.payload,
        index = _action$payload6.index,
        name = _action$payload6.name;
      var path = (0, _lodash.toPath)(name);
      var value = (0, _lodash.get)(state.touched, path);
      if (value) {
        value.splice(index, 1);
        (0, _lodash.set)(state.touched, path, _toConsumableArray(value));
      }
      state.touched = (0, _keepOrUnsetPathRecursively["default"])(state.touched, path);
      return state;
    },
    setTouched: function setTouched(state, action) {
      var _action$payload7 = action.payload,
        name = _action$payload7.name,
        _action$payload7$valu = _action$payload7.value,
        value = _action$payload7$valu === void 0 ? true : _action$payload7$valu;
      (0, _lodash.set)(state.touched, name, value);
      return state;
    },
    //
    // values
    //
    setInitialValues: function setInitialValues(state, action) {
      state.values = action.payload.initialValues;
      return state;
    },
    setDefaultValue: function setDefaultValue(state, action) {
      var _action$payload8 = action.payload,
        name = _action$payload8.name,
        value = _action$payload8.value;
      if ((0, _lodash.get)(state.values, name) === undefined) {
        (0, _lodash.set)(state.values, name, value);
      }
      return state;
    },
    setGroupValue: function setGroupValue(state, action) {
      var _action$payload9 = action.payload,
        name = _action$payload9.name,
        value = _action$payload9.value;
      var values = (0, _lodash.get)(state.values, name, []);
      (0, _lodash.set)(state.values, name, (0, _lodash.uniq)([].concat(values, [value])));
      return state;
    },
    unsetGroupValue: function unsetGroupValue(state, action) {
      var _action$payload10 = action.payload,
        name = _action$payload10.name,
        value = _action$payload10.value;
      var values = (0, _lodash.get)(state.values, name, []);
      (0, _lodash.set)(state.values, name, values.filter(function (it) {
        return it !== value;
      }));
      return state;
    },
    setValue: function setValue(state, action) {
      (0, _lodash.set)(state.values, action.payload.name, action.payload.value);
      return state;
    },
    addItemToValuesArray: function addItemToValuesArray(state, action) {
      var newValue = (0, _lodash.cloneDeep)(action.payload.defaultValue || {});
      var v = (0, _lodash.get)(state.values, (0, _lodash.toPath)(action.payload.name));
      if (!v) {
        v = [newValue];
      } else {
        v.push(newValue);
      }
      (0, _lodash.set)(state.values, action.payload.name, v);
      return state;
    },
    addMinimumItemsToValuesArray: function addMinimumItemsToValuesArray(state, action) {
      var newValue = (0, _lodash.cloneDeep)(action.payload.defaultValue || {});
      var v = (0, _lodash.get)(state.values, (0, _lodash.toPath)(action.payload.name));
      if (!v) {
        v = [];
        for (var i = 0; i < action.payload.minimumItems && v.length < action.payload.minimumItems; i++) {
          v.push(newValue);
        }
      } else {
        for (var _i2 = 0; _i2 < action.payload.minimumItems && v.length < action.payload.minimumItems; _i2++) {
          v.push(newValue);
        }
      }
      (0, _lodash.set)(state.values, action.payload.name, v);
      return state;
    },
    removeItemFromValueArray: function removeItemFromValueArray(state, action) {
      var _action$payload11 = action.payload,
        index = _action$payload11.index,
        name = _action$payload11.name;
      var path = (0, _lodash.toPath)(name);
      var value = (0, _lodash.get)(state.values, path);
      if (value) {
        value.splice(index, 1);
        (0, _lodash.set)(state.values, path, _toConsumableArray(value));
      }
      return state;
    }
  }
});
var _formSlice$actions = formSlice.actions,
  clearForm = exports.clearForm = _formSlice$actions.clearForm,
  setError = exports.setError = _formSlice$actions.setError,
  setErrors = exports.setErrors = _formSlice$actions.setErrors,
  removeItemFromErrorsArray = exports.removeItemFromErrorsArray = _formSlice$actions.removeItemFromErrorsArray,
  validateField = exports.validateField = _formSlice$actions.validateField,
  checkForceShowErrors = exports.checkForceShowErrors = _formSlice$actions.checkForceShowErrors,
  clearForceShowErrors = exports.clearForceShowErrors = _formSlice$actions.clearForceShowErrors,
  setFocused = exports.setFocused = _formSlice$actions.setFocused,
  setForceShowErrors = exports.setForceShowErrors = _formSlice$actions.setForceShowErrors,
  setMetaValue = exports.setMetaValue = _formSlice$actions.setMetaValue,
  removeItemFromTouchedArray = exports.removeItemFromTouchedArray = _formSlice$actions.removeItemFromTouchedArray,
  setTouched = exports.setTouched = _formSlice$actions.setTouched,
  setInitialValues = exports.setInitialValues = _formSlice$actions.setInitialValues,
  setDefaultValue = exports.setDefaultValue = _formSlice$actions.setDefaultValue,
  setGroupValue = exports.setGroupValue = _formSlice$actions.setGroupValue,
  unsetGroupValue = exports.unsetGroupValue = _formSlice$actions.unsetGroupValue,
  setValue = exports.setValue = _formSlice$actions.setValue,
  addItemToValuesArray = exports.addItemToValuesArray = _formSlice$actions.addItemToValuesArray,
  addMinimumItemsToValuesArray = exports.addMinimumItemsToValuesArray = _formSlice$actions.addMinimumItemsToValuesArray,
  removeItemFromValueArray = exports.removeItemFromValueArray = _formSlice$actions.removeItemFromValueArray;
var _default = exports["default"] = formSlice.reducer;